import React from "react";

import EventViewStore from "@state/stores/offer/event/EventViewStore.mobile";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { observer } from "mobx-react";

import { TeamStandingsSection } from ".";
import { EventContentSkeleton } from "../../../event";

export default observer(function TeamStandings({
	store,
}: {
	store: EventViewStore | AdditionalOfferViewStore;
}) {
	if (store.teamStandingsStatsStore.loader.isLoading) {
		return <EventContentSkeleton />;
	}

	if (!store.teamStandingsStatsStore.teamStandingsStats?.data) {
		return null;
	}

	return (
		<>
				<div className="event__content">
					<TeamStandingsSection
						store={store.teamStandingsStatsStore}
					/>
				</div>
		</>
	);
});
